// import Swiper JS
import Swiper from 'swiper';


export const cardSlider = () => {


	const cardSliderModules = document.querySelectorAll('.m__cslider');
	cardSliderModules.forEach((cardSliderModule) => { //Loop through each card slider and initialise swiper and buttons
		let cardSliderSwiper = cardSliderModule.querySelector('.swiper');
        let cardSlidesCount = cardSliderModule.querySelectorAll('.m__cslider__swiper-slide').length;
		let thisCSwiper = new Swiper(cardSliderSwiper, {
            init: false,
			slidesPerView : 1,
			centeredSlides : false,
			rewind : false,
			keyboard: {
				enabled: true,
				onlyInViewport: true,
			},
            loop: true,
			breakpoints: {
				1200: {
					slidesPerView: 4,
				},
                992: {
                    slidesPerView: 3,
                },
				768: {
					slidesPerView: 2,
				},
			}
		});

		let thisCSliderNextArrow = cardSliderModule.querySelector('.js__cslider__swiper-next');
		let thisCSliderPrevArrow = cardSliderModule.querySelector('.js__cslider__swiper-prev');

		//Move to next slide if 'next' arrow clicked
		if(thisCSliderNextArrow){
			thisCSliderNextArrow.addEventListener('click', (event) => {
				thisCSwiper.slideNext();
			})
		}
        
		if(thisCSliderPrevArrow){
            thisCSliderPrevArrow.addEventListener('click', (event) => {
                thisCSwiper.slidePrev();
			})
		}

        thisCSwiper.on('init', (swiper) => {
            let slidesPerView = 1;

            if ( window.innerWidth >= 768 && window.innerWidth < 992 ) {
                slidesPerView = 2;
            }

            if ( window.innerWidth >= 992 && window.innerWidth < 1199 ) {
                slidesPerView = 3;
            }

            if ( window.innerWidth >= 1200 ) {
                slidesPerView = 4;
            }

            toggleArrows(cardSlidesCount, slidesPerView, thisCSliderPrevArrow, thisCSliderNextArrow);
        });

        thisCSwiper.init();

        thisCSwiper.on('breakpoint', (swiper, breakpointParams) => {
            toggleArrows(cardSlidesCount, breakpointParams.slidesPerView, thisCSliderPrevArrow, thisCSliderNextArrow);
        });
	});
	//Initialise the slider
}

function toggleArrows(slideCount, slidesPerView, prevArrow, nextArrow) {
    console.log('slideCount:' + slideCount);
    console.log('slidesPerView:' + slidesPerView);

    if(prevArrow && nextArrow){

        if ( slidesPerView >= slideCount ) {
            prevArrow.classList.add('hidden');
            nextArrow.classList.add('hidden');
        } else {
            prevArrow.classList.remove('hidden');
            nextArrow.classList.remove('hidden');
        }
    }
}